import { render, staticRenderFns } from "./ShopImagesAlbumField.vue?vue&type=template&id=fdfbc478&scoped=true"
import script from "./ShopImagesAlbumField.vue?vue&type=script&lang=ts"
export * from "./ShopImagesAlbumField.vue?vue&type=script&lang=ts"
import style0 from "./ShopImagesAlbumField.vue?vue&type=style&index=0&id=fdfbc478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfbc478",
  null
  
)

export default component.exports